import { Logger, LoggerFactory } from './../../core/logger.service';
import { LoaderService, LoaderState } from './../../core/loader.service';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-bar-loader',
  templateUrl: 'bar-loader.component.html',
  styleUrls: ['bar-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BarLoaderComponent implements OnInit, OnDestroy {
  public show: boolean;
  public logger: Logger;
  private subscription: Subscription;
  private subscriptionArray: Subscription[] = [];

  constructor(
    private readonly loaderService: LoaderService,
    loggerFactory: LoggerFactory,
  ) {
    this.logger = loggerFactory.get('BarLoaderComponent');
  }

  public ngOnInit() {
    this.subscription = this.loaderService.onStateChanged.subscribe((state: LoaderState) => {
      this.show = state.isBusy;
    });
  }
  public ngOnDestroy() {
    this.subscriptionArray.push(this.subscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
